'use client'

import { ReactNode, useCallback, useMemo } from 'react'

import {
  CartItem,
  CategoryAccTypes,
  sortCartItemsByCategory
} from 'modules/cart'
import { getProperProductForm } from 'modules/products'

import styles from './ProfileSaleOrderProductsGroupedList.module.scss'

interface ProfileSaleOrderProductsGroupedListProps {
  items: CartItem[]
  renderItem: (item: CartItem) => ReactNode
}

const ProfileSaleOrderProductsGroupedList = ({
  items,
  renderItem
}: ProfileSaleOrderProductsGroupedListProps) => {
  const groupedItems = useMemo(() => sortCartItemsByCategory(items), [items])
  const renderCategoryItems = useCallback(
    (category: CategoryAccTypes) =>
      category.items.map(item => renderItem(item)),
    [renderItem]
  )

  return (
    <div className={styles.listWrapperDetails}>
      {groupedItems.map(category => (
        <div
          className={styles.categoryWrapperDetails}
          key={`${category.categoryId}-${category.categoryName}`}
        >
          <div className={styles.categoryHeaderDetails}>
            <span>{category.categoryName}</span>
            <span className={styles.productsCountDetails}>
              {getProperProductForm(category.items.length)}
            </span>
          </div>
          {renderCategoryItems(category)}
        </div>
      ))}
    </div>
  )
}

export default ProfileSaleOrderProductsGroupedList
